import React from 'react';
import Icon from '@/common/components/Icon';
import { Colors } from '@/common/colors/colors';
import { COPY, SEARCH_ICON } from './constants/pageSearch.constants';
import { usePageSearch } from './hooks/usePageSearch';
import SectionChips from './components/SectionChips';
import ResultRow from './components/ResultRow';
import {
	Card,
	Empty,
	Footer,
	GroupTitle,
	Header,
	Input,
	Kbd,
	Overlay,
	Results,
	SearchRow,
} from './PageSearch.styles';

const PageSearch = ({ show, setShow }) => {
	const search = usePageSearch({ show, setShow });

	if (!show) {
		return null;
	}

	return (
		<Overlay onMouseDown={() => setShow(false)}>
			<Card onMouseDown={(event) => event.stopPropagation()}>
				<Header>
					<SearchRow>
						<Icon name={SEARCH_ICON} size={18} color={Colors.darkGray2} />
						<Input
							autoFocus
							placeholder={COPY.PLACEHOLDER}
							value={search.query}
							onChange={(event) => search.handleQueryChange(event.target.value)}
							onKeyDown={search.handleInputKeyDown}
						/>
						<Kbd>{COPY.ESCAPE_HINT}</Kbd>
					</SearchRow>
					<SectionChips
						chips={search.chips}
						totalCount={search.totalCount}
						section={search.section}
						getChipColor={search.getChipColor}
						onChange={search.handleSectionChange}
					/>
				</Header>
				<Results>
					{search.groups.length === 0 && <Empty>{COPY.NO_RESULTS}</Empty>}
					{search.groups.map((group) => (
						<div key={group.section}>
							<GroupTitle color={group.color}>{group.section}</GroupTitle>
							{group.rows.map(({ item, index }) => (
								<ResultRow
									key={`${item.section}-${item.name}`}
									item={item}
									color={group.color}
									tokens={search.tokens}
									active={index === search.activeIndex}
									onHover={() => search.setActiveIndex(index)}
									onSelect={search.handleSelect}
								/>
							))}
						</div>
					))}
				</Results>
				<Footer>
					<span>
						<Kbd>{COPY.ARROW_UP}</Kbd> <Kbd>{COPY.ARROW_DOWN}</Kbd>{' '}
						{COPY.NAVIGATE_HINT}
					</span>
					<span>
						<Kbd>{COPY.ENTER_HINT}</Kbd> {COPY.OPEN_HINT}
					</span>
					<span>
						<Kbd>{COPY.ESCAPE_HINT}</Kbd> {COPY.CLOSE_HINT}
					</span>
				</Footer>
			</Card>
		</Overlay>
	);
};

export default PageSearch;
